import { FormControl, InputLabel, makeStyles, useTheme } from '@material-ui/core';
import { TGTextInput } from '.';

interface Props {
  id: string;
  value: string | number;
  label?: string;
  onChange: (value: string) => void;
  onBlur?: (value: string) => void;
  labelClass?: string;
  inputClass?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export const TGTextInputWithLabel = ({
  id,
  value,
  label,
  onBlur,
  onChange,
  labelClass,
  inputClass,
  placeholder,
  disabled,
  className = '',
}: Props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <FormControl className={`${classes.formControl} ${className}`}>
      {Boolean(label) && (
        <InputLabel shrink htmlFor={id} className={`${classes.inputLabel} ${labelClass ?? ''}`}>
          {label}
        </InputLabel>
      )}
      <TGTextInput
        defaultValue="Project"
        value={value}
        id={id}
        onBlur={onBlur}
        onChange={onChange}
        disabled={disabled}
        className={inputClass}
        placeholder={placeholder}
      />
    </FormControl>
  );
};

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
  },
  inputLabel: {
    fontSize: 15,
    color: theme.palette.text.primary,
    '&.MuiInputLabel-shrink': {
      transform: 'translate(0, -3px) scale(1)',
    },
  },
}));
